import AppEnvironment from "./AppEnvironment";

const Url = {
  verifyMobileNumber: baseUrl() + "/app/auth/check-number",
  user_register: baseUrl() + "/app/auth/register",
  user_login: baseUrl() + "/app/auth/login",
  user_logout: baseUrl() + "/app/auth/logout",
  refreshToken: baseUrl() + "/app/auth/refresh-token",
  trustList: baseUrl() + "/app/trust/trusts",
  languageList: baseUrl() + "/app/language",
  setUserLanguage: baseUrl() + "/app/user/language",
  getUserDetails: baseUrl() + "/app/user/get-detail",
  getAllNews: baseUrl() + "/app/news",
  getTodayExclusive: baseUrl() + "/app/todays-exclusive",
  get_trust_notice: baseUrl() + "/app/trust/get-notice",

  getTodayExclusiveRandom: baseUrl() + "/app/todays-exclusive/random",
  subscribe: baseUrl() + "/app/user/subscribe",
  unSubscribe: baseUrl() + "/app/user/unsubscribe",
  dispute: baseUrl() + "/app/dispute/",
  addPanCard: baseUrl() + "/app/user/add-pan",
  updatePreference: baseUrl() + "/app/user/preference",
  masterCategory: baseUrl() + "/app/category/",
  subcategory: baseUrl() + "/app/category/sub-category",
  insightTotalDonationAmount: baseUrl() + "/app/insight/total-amount",
  getTrustSubscriptionsList: baseUrl() + "/app/trust/subscriptions",
  getTodaysExclusive: baseUrl() + "/app/thought",
  getCommitmentList: baseUrl() + "/app/commitment",
  makeCommitmentPayment: baseUrl() + "/app/commitment/make-payment",
  saveUserProfileDetails: baseUrl() + "/app/user/save-detail",
  getEventList: baseUrl() + "/app/trust/events",
  getNotices: baseUrl() + "/app/trust/notices",
  getTrustNews: baseUrl() + "/app/trust/news",
  getTrustEvents: baseUrl() + "/app/trust/events",
  makeDonation: baseUrl() + "/app/donation/create",
  updateDonation: baseUrl() + "/app/donation/update",
  deleteDonation: baseUrl() + "/app/donation/delete",
  donatedTrusts: baseUrl() + "/app/donation",
  getAdvertisement: baseUrl() + "/app/advertisement",
  getAdvertisementDetails: baseUrl() + "/app/advertisement/get",
  apnamandir_godList: baseUrl() + "/app/apna-mandir/gods",
  apnamandir_frames: baseUrl() + "/app/apna-mandir/background",
  create_apnamandir: baseUrl() + "/app/apna-mandir/create-mandir",
  get_user_mandir: baseUrl() + "/app/apna-mandir/get-mandir",
  getMediaVideos: baseUrl() + "/app/media/video",
  getMediaAudio: baseUrl() + "/app/media/audio",
  allEvent: baseUrl() + "/app/event/",
  state_city: baseUrl() + "/super-admin/state/",
  getTrustDetail: baseUrl() + "/app/trust/",
  punyarjak_detail: baseUrl() + "/app/trust/punyarjak-detail",

  getEventDates: baseUrl() + "/app/event/get-dates",
  jinvaniCategoriesList: baseUrl() + "/app/jinvani/categories",
  jinvaniList: baseUrl() + "/app/jinvani/",
  jinvaniChaptersList: baseUrl() + "/app/jinvani/chapters",
  jinvaniChaptersPageList: baseUrl() + "/app/jinvani/pages",
  punyarjak: baseUrl() + "/app/trust/punyarjak",
  eventDetails: baseUrl() + "/app/event/get-event",
  newsDetails: baseUrl() + "/app/news/get-news",
  exclusiveDetails: baseUrl() + "/app/todays-exclusive/get-exclusive",
  createInquiry: baseUrl() + "/app/inquiry/create",
  createFeedback: baseUrl() + "/app/feedback/create",
  updateProfileImage: baseUrl() + "/app/user/update-profile",
  getTrustType: baseUrl() + "/app/trust/trust-type",
  globalSearch: baseUrl() + "/app/global",
  deleteAccount: baseUrl() + "/app/user/delete",
  fileUpload: baseUrl() + "",
  jinvani_category: baseUrl() + "/app/jinvani/categories",
  app_preference: baseUrl() + "/app/preference",

  createGetHelpRequest: baseUrl() + "/app/help/create",
  get_business_types: baseUrl() + "/app/inquiry/business-types",

  get_trust_facility: baseUrl() + "/app/trust/trust-facility",

  bar_chart_total_donation: baseUrl() + "/app/insight/chart-data",
  pie_chart_total_donation: baseUrl() + "/app/insight/total-category-donation",

  get_top_donars: baseUrl() + "/app/trust/top-donars",

  switch_all_notification: baseUrl() + "/app/user/all-notification",
  switch_account_notification: baseUrl() + "/app/user/account-notification",
  switch_promotional_notification:
    baseUrl() + "/app/user/promotional-notification",

  social_login: baseUrl() + "/app/auth/social/login",

  reversGeoCoding: "https://maps.googleapis.com/maps/api/geocode/json?",
  vedicBasic: "https://json.astrologyapi.com/v1/basic_panchang",

  own_hindu_calendar: baseUrl() + "/public/calendar",
  get_month_hindu_calendar: baseUrl() + "/public/calendar/month",

  //CashFree
  pg_create_order: baseUrl() + "/app/order/create",

  notification_list: baseUrl() + "/app/notification",
  notification_seen: baseUrl() + "/app/notification/seen",

  device_register: baseUrl() + "/app/auth/register-device",
  force_update: baseUrl() + "/app/app-version",

  delete_account: baseUrl() + "'/app/delete'",
  receipt_download: baseUrl() + "/public/donation-pdf/download-pdf",
  commitment_receipt_download:
    baseUrl() + "/public/donation-pdf/download-commitment",
  verify_mail: baseUrl() + "/app/user/verify-mail",
};

const s3Bucket = {
  name: s3BucketName(),
};

const cashfreeUrls = {
  pancard_verification: cashfreeBaseUrl() + "/verification/pan",
};

function cashfreeBaseUrl() {
  if (
    AppEnvironment.current === AppEnvironment.Type.development ||
    AppEnvironment.Type.staging
  ) {
    return "https://sandbox.cashfree.com";
  } else {
    return "https://api.cashfree.com";
  }
}

function baseUrl() {
  if (AppEnvironment.current === AppEnvironment.Type.development) {
    // Point to local API server instead of remote dev server so we hit local code
    return "https://api.apnadharm.dev/v1";
  } else if (AppEnvironment.current === AppEnvironment.Type.staging) {
    return "https://api.apnadharm.in/v1";
  } else if (AppEnvironment.current === AppEnvironment.Type.local) {
    return "http://10.0.2.2:3005/v1";
  } else {
    return "https://api.apnadharm.com/v1";
  }
}

function s3BucketName() {
  if (AppEnvironment.current === AppEnvironment.Type.staging) {
    return "apnamandir-staging";
  } else if (AppEnvironment.current === AppEnvironment.Type.development) {
    return "apnamandir";
  } else if (AppEnvironment.current === AppEnvironment.Type.production) {
    return "apnadharm-prod";
  }
}

function getPrivacyPolicy() {
  return "https://apnadharm.com/privacy-policy";
  // if (AppEnvironment.current === AppEnvironment.Type.development) {
  //   return 'https://api-am-dev.paridhan.app/privacy-policy'
  // } else if (AppEnvironment.current === AppEnvironment.Type.staging) {
  //   return "https://api-am-staging.paridhan.app/privacy-policy"
  // } else if (AppEnvironment.current === AppEnvironment.Type.production) {
  //   return "https://api-am-production.paridhan.app/privacy-policy"
  // }
}

function getTermsConditions() {
  return "https://apnadharm.com/terms-conditions";

  // if (AppEnvironment.current === AppEnvironment.Type.development) {
  //   return 'https://api-am-dev.paridhan.app/terms-conditions'
  // } else if (AppEnvironment.current === AppEnvironment.Type.staging) {
  //   return "https://api-am-staging.paridhan.app/terms-conditions"
  // } else if (AppEnvironment.current === AppEnvironment.Type.production) {
  //   return "https://api-am-production.paridhan.app/terms-conditions"
  // }
}

function deepLinkUrl() {
  if (AppEnvironment.current === AppEnvironment.Type.development) {
    return "https://share.apnadharm.dev";
  } else if (AppEnvironment.current === AppEnvironment.Type.staging) {
    return "https://share.apnadharm.in";
  } else if (AppEnvironment.current === AppEnvironment.Type.local) {
    return "http://10.0.2.2:3005/v1";
  } else {
    return "https://share.apnadharm.com";
  }
}

const deeplink_base_url = deepLinkUrl();

const DeeplinkUrls = {
  punyarjak: deeplink_base_url + "/trust/punyarjak-detail",
  event: deeplink_base_url + "/event/get-event",
  trust: deeplink_base_url + "/app/trust/",
  punyarjak_detail: deeplink_base_url + "/app/trust/punyarjak-detail",
  news: deeplink_base_url + "/app/news/get-news",
};

const aws3 = {
  AWS_REGION: "ap-south-1",
  AWS_IDENTITYPOOLID: "ap-south-1:a852d5e8-4f7c-4fbf-a1ea-2c9d5eb04721",
  AWS_S3_BUCKET_NAME: "apnamandir",
  AWS_S3_RESUOURCE_FOLDER: "public/temp",
};

const googleService = {
  API_MAP_KEY: "AIzaSyDs_3VzPUtrHV6s5XkaA_9AMvSCCprNdM8",
  GOOGLE_iOS_OAUTH_CLIENT_:
    "821319961998-traentk3h0m4ekuakkei0na67keusjl9.apps.googleusercontent.com",
  GOOGLE_ANDROID_OAUTH_CLIENT_:
    "821319961998-2cb0kq304piap5ovbfc6a1rdci12lsj5.apps.googleusercontent.com",
};

export default {
  s3Bucket,
  aws3,
  googleService,
  Url,
  cashfreeUrls,
  baseUrl,
  getPrivacyPolicy,
  getTermsConditions,
  DeeplinkUrls,
};
